import { Car } from '../_classes/list/car';

export let Cars: Car[] = [
  {
    id: 1,
    name: 'ваз-2109',
    color: 'снежная королева',
    gos_no: 'е345не174',
    firm_id: 1,
    firm: 'КЦСОН Калининского',
    user_id: 1,
    user: 'И.И. Иванов',
    driver_name: 'Анатолий',
    driver_phone: '8 909 909 909',
    type: false,
    status: true
  },
  {
    id: 2,
    name: 'ваз-2110',
    color: 'баклажан',
    gos_no: 'у435ка174',
    firm_id: 1,
    firm: 'КЦСОН Калининского',
    user_id: 1,
    user: 'И.И. Иванов',
    driver_name: 'Гоша',
    driver_phone: '8 999 909 909',
    type: false,
    status: true
  },
  {
    id: 3,
    name: 'ПАЗ-31010',
    color: 'синий сапфир',
    gos_no: 'а412ао74',
    firm_id: 1,
    firm: 'КЦСОН Калининского',
    user_id: 1,
    user: 'И.И. Иванов',
    driver_name: 'Петро',
    driver_phone: '8 909 888 888',
    type: true,
    status: true
  }
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/cars.ts